// "Qual tamanho da sua fome?" — as duas opções do produto com combo, no
// estilo da referência: Combo (recomendado) primeiro, depois Individual.
import { Check } from "lucide-react";

import { fmt, getImageUrl } from "../../lib/helpers";

export default function EscolhaCombo({ h }) {
  const { product, selectedComboType, handleSelectComboType, comboPrice, simplePrice, comboPricePromo, simplePricePromo } = h;
  const opcoes = [
    { tipo: "combo", titulo: product.combo_description ? `${product.name} + ${product.combo_description}` : `${product.name} (Combo)`, foto: product.combo_photo_url || product.photo_url, preco: comboPrice, promo: comboPricePromo, recomendado: true },
    { tipo: "simples", titulo: product.simple_description ? `${product.name} · ${product.simple_description}` : product.name, foto: product.simple_photo_url || product.photo_url, preco: simplePrice, promo: simplePricePromo, recomendado: false },
  ];
  return (
    <div data-e2e="escolha-combo">
      <h2 className="text-3xl md:text-4xl font-black text-zinc-100 mb-5">Qual tamanho da sua fome?</h2>
      <div className="space-y-5">
        {opcoes.map((o) => {
          const ativa = selectedComboType === o.tipo;
          const temPromo = o.promo != null && o.promo !== o.preco;
          return (
            <button
              key={o.tipo}
              type="button"
              onClick={() => handleSelectComboType(o.tipo)}
              data-e2e={`opcao-${o.tipo}`}
              data-ativa={ativa ? "1" : "0"}
              className={`w-full flex items-center gap-8 rounded-3xl border-[3px] p-6 text-left transition-all active:scale-[0.99] ${ativa ? "border-primary bg-primary/15 ring-4 ring-primary/25 shadow-2xl shadow-primary/20" : "border-zinc-800 bg-zinc-900 hover:border-zinc-600"}`}
            >
              <div className="w-64 h-48 rounded-2xl overflow-hidden bg-zinc-800 shrink-0">
                {o.foto ? <img src={getImageUrl(o.foto)} alt="" className="w-full h-full object-contain" /> : <div className="w-full h-full flex items-center justify-center text-5xl">🍽️</div>}
              </div>
              <div className="flex-1 min-w-0">
                {o.recomendado && <span className="inline-block mb-3 px-3 py-1 rounded-md bg-emerald-500 text-white text-sm font-black tracking-wide">RECOMENDADO</span>}
                <p className="text-3xl md:text-4xl font-bold text-zinc-100 leading-tight">{o.titulo}</p>
                {temPromo ? (
                  <p className="mt-2"><span className="text-xl line-through text-zinc-500 mr-3">R$ {fmt(o.preco)}</span><span className="text-3xl md:text-4xl font-black text-green-500">R$ {fmt(o.promo)}</span></p>
                ) : (
                  <p className={`text-3xl md:text-4xl font-black mt-2 ${ativa ? "text-primary" : "text-zinc-100"}`}>R$ {fmt(o.preco)}</p>
                )}
              </div>
              <div className={`w-14 h-14 rounded-full border-[3px] flex items-center justify-center shrink-0 transition-all ${ativa ? "border-primary bg-primary scale-110" : "border-zinc-500"}`}>
                {ativa && <Check className="w-8 h-8 text-primary-foreground" strokeWidth={3} />}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
